import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendCustomerSubscription,
  BackendMutationCancelCustomerSubscriptionArgs,
} from 'src/types/backend';

const MUTATION = gql`
  mutation CancelCustomerSubscription($customerId: ID!, $reason: String!, $comment: String) {
    cancelCustomerSubscription(customerId: $customerId, reason: $reason, comment: $comment) {
      status
    }
  }
`;

type Variables = BackendMutationCancelCustomerSubscriptionArgs;
type Result = Pick<BackendCustomerSubscription, 'status'>;

export const cancelCustomerSubscription = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
